import {
  ClockWarningIcon,
  MegaphoneIcon,
  PhotoClickIcon,
  StarPlusIcon,
  UserCheckIcon,
} from "@pharmupp/p3-front-commons"
import { OperationSection } from "../../model"
import { GridContainer } from "../commons"
import { StatusCard } from "./StatusCard"
import { useMyMarketingOpSummary } from "./useMyMarketingOpSummary"

export const AdhMarketingOpSummary = ({
  listLink,
  year = new Date().getFullYear(),
  adherentId,
  compact = false,
}: {
  listLink: string
  adherentId?: string
  year?: number
  compact?: boolean
}) => {
  const { operationsSheet: summary, isLoading } = useMyMarketingOpSummary({
    year,
    id: adherentId,
  })

  return (
    <GridContainer>
      <StatusCard
        title="Opérations"
        Icon={MegaphoneIcon}
        count={summary?.ALL.count}
        link={`${listLink}?filters%5Byear%5D=${year}`}
        dividerAccent
        isLoading={isLoading}
        compact={compact}
      />
      <StatusCard
        title="Inscriptions"
        Icon={UserCheckIcon}
        count={summary?.REGISTERED.count}
        variant="info"
        link={`${listLink}?filters%5Byear%5D=${year}&filters%5Bsection%5D=${OperationSection.REGISTERED}`}
        isLoading={isLoading}
        compact={compact}
      />
      <StatusCard
        title="Auxquelles s’inscrire"
        Icon={ClockWarningIcon}
        count={summary?.REGISTRABLE.count}
        variant="info"
        link={`${listLink}?filters%5Byear%5D=${year}&filters%5Bsection%5D=${OperationSection.REGISTRABLE}`}
        isLoading={isLoading}
        compact={compact}
      />
      <StatusCard
        title="À justifier"
        Icon={PhotoClickIcon}
        count={summary?.REQUIRES_PROOF.count}
        variant="warning"
        link={`${listLink}?filters%5Byear%5D=${year}&filters%5Bsection%5D=${OperationSection.REQUIRES_PROOF}`}
        isLoading={isLoading}
        compact={compact}
      />
      <StatusCard
        title="Validées"
        Icon={StarPlusIcon}
        count={summary?.VALIDATED.count}
        pointsCount={summary?.VALIDATED.pointsCount}
        variant="success"
        link={`${listLink}?filters%5Byear%5D=${year}&filters%5Bsection%5D=${OperationSection.VALIDATED}`}
        isLoading={isLoading}
        divider={false}
        compact={compact}
      />
    </GridContainer>
  )
}
